import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92431012"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, "theo dõi thực hiện hợp đồng", -1))
const _hoisted_2 = {
  class: "text-center mb-2 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_3 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_4 = {
  key: 0,
  class: "theo-doi-hop-dong-info mb-3"
}
const _hoisted_5 = { class: "theo-doi-hop-dong-info-row mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "theo-doi-hop-dong-info-label" }, "Hợp đồng cung cấp vật tư hàng hoá số:", -1))
const _hoisted_7 = { class: "theo-doi-hop-dong-info-row mb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "theo-doi-hop-dong-info-label" }, "Tên đơn vị cấp vật tư, hàng hoá:", -1))
const _hoisted_9 = { class: "theo-doi-hop-dong-info-row mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "theo-doi-hop-dong-info-label" }, "Tài khoản:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_12 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_13 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, PropType } from 'vue';
import {
  IHopDongResponseBase,
  IKhoResponseBase,
  ITheoDoiThucHienHopDongResponseBase,
} from '@/core/interfaces/ApiResponses';
import {
  getPdfPrintContentStyle,
  PDF_BAO_CAO_MARGINS,
} from '@/components/shared/pdf-viewer/pdf-content.config';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import SignatureCol from '@/layout/_shared/SignatureCol.vue';
import TheoDoiHopDongTable from '../table-components/TheoDoiHopDongTable.vue';
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiHopDongPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  hopDong: {
    type: Object as PropType<IHopDongResponseBase | null>,
    default: null,
  },
  items: {
    type: Array as PropType<ITheoDoiThucHienHopDongResponseBase[]>,
    default: () => [],
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  to: { type: Date, default: () => new Date() },
},
  setup(__props) {

const paperStyle = getPdfPrintContentStyle({
  orientation: 'landscape',
  margins: PDF_BAO_CAO_MARGINS,
});

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const dateDisplay = computed(
  () => `Đến tháng ${props.to.getMonth() + 1} năm ${props.to.getFullYear()}`,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "printing-paper",
    style: _normalizeStyle(_unref(paperStyle))
  }, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createVNode(DivRow, { class: "row mb-3" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 3 }),
        _createVNode(DivCol, { cols: 6 }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("p", _hoisted_2, _toDisplayString(dateDisplay.value), 1),
            _createElementVNode("p", _hoisted_3, " Nhập tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
          ]),
          _: 1
        }),
        _createVNode(DivCol, { cols: 3 })
      ]),
      _: 1
    }),
    (__props.hopDong)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(__props.hopDong.so_hop_dong) + " Ngày " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getDate()) + " Tháng " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getMonth() + 1) + " năm " + _toDisplayString(new Date(__props.hopDong.ngay_ky).getFullYear()), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(__props.hopDong.ten_doi_tac), 1)
          ]),
          _createElementVNode("p", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(__props.hopDong.ma_tk) + " / " + _toDisplayString(__props.hopDong.ma_ct), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_11,
    _createVNode(DivRow, { class: "row mt-2" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 12 }, {
          default: _withCtx(() => [
            _createVNode(TheoDoiHopDongTable, {
              "is-print-modal": true,
              items: __props.items,
              stripe: false
            }, null, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
      ])
    ])
  ], 4))
}
}

})